import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Configure Amplify for both SAML (KONE-AzureAD) and Cognito authentication (v6 syntax)
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'eu-west-1_Up3KPvVex',
      userPoolClientId: '2j8j8np8jkakkhoof8omsaqidv',
      loginWith: {
        oauth: {
          domain: 'eu-west-1up3kpvvex.auth.eu-west-1.amazoncognito.com',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: ['http://localhost:3000/', 'https://dqzpu22zgf128.cloudfront.net/','https://resolveguru.dev.srdops.com/'],
          redirectSignOut: ['http://localhost:3000/', 'https://dqzpu22zgf128.cloudfront.net/','https://resolveguru.dev.srdops.com/'],
          responseType: 'code',
          providers: ['KONE-AzureAD'] // SAML provider
        }
      }
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();